export default function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {

      let img = $('#img_prev');

      img
        .attr('src', e.target.result)
        .width(img.data().width)
        .height(img.data().height);
    };

    reader.readAsDataURL(input.files[0]);
  }
}


// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/read_url.js